import { isEqual } from 'lodash'

import * as api from './api'
import * as types from './constants'

function warmUpImages(tasksMap, dispatch) {
	tasksMap.forEach((task) => {
		if (task.payload && task.payload.image) {
			const i = new Image()
			i.onerror = () => {
				dispatch({
					type: types.FAIL_LOAD_TASK,
					id: task.id,
				})
				api.fail(task)
			}
			i.src = task.payload.image
		}
	})
}

export const getTasks = (preset, toolType) => (dispatch) => {
	dispatch({
		type: types.GET_TASKS_REQUEST,
	})

	return api.getTask(preset)
		.then((data) => {
			warmUpImages(data.data.assignments, dispatch)

			dispatch({
				type: types.GET_TASKS_SUCCESS,
				toolType,
				preset,
				assignments: data.data.assignments,
				onboarding: data.data.onboarding,
				expiration_timeout: data.data.expiration_timeout,
				onboarding_status: data.data.onboarding_status,
				isMock: data.isMock || false,
			})
		})
		.catch(() => {
			dispatch({
				type: types.GET_TASKS_ERROR,
			})
			return true
		})
}

export const resetTasks = () => (dispatch) => {
	dispatch({
		type: types.RESET_TASKS,
	})
}

export const loadPrevTask = () => (dispatch) => {
	dispatch({
		type: types.LOAD_PREV_TASK,
	})
}

export const markTask = (task, payload, userData, skip) => (dispatch) => {
	dispatch({
		type: types.MARK_TASK_REQUEST,
		task,
		userData,
	})

	return api.mark(task, payload, skip)
		.then(() => {
			dispatch({
				type: types.MARK_TASK_SUCCESS,
			})
		})
		.catch(() => {
			dispatch({
				type: types.MARK_TASK_ERROR,
			})
			return true
		})
}

export const normalizePoints = (array, selectedPath) => (dispatch) => {
	dispatch({
		type: types.POINTS_NORMALIZER_REQUEST,
	})

	api.normalizePoints(array)
		.then((response) => {
			const { data } = response

			if (data && data.statusCode !== undefined && data.statusCode === 200) {
				return data.body.points
			}

			throw new Error('')
		})
		.then((points) => {
			dispatch({
				type: types.POINTS_NORMALIZER_SUCCESS,
				normalizedPaths: { [selectedPath]: points },
			})
		})
		.catch(() => {
			dispatch({
				type: types.POINTS_NORMALIZER_FAILED,
			})
		})
}

export const compareRanges = (user, result, type) => (dispatch) => {
	dispatch({
		type: types.COMPARE_RANGES_REQUEST,
	})

	let errors = 0
	const comparedResult = {
		result,
		user,
		score: 0,
	}

	const resultKeys = Object.keys(result)

	resultKeys.forEach((rKey) => {
		if (
			(result[rKey].length !== user[rKey].length) ||
			(!isEqual(user[rKey], result[rKey]))
		) {
			errors += 1
		}
	})

	if (errors === 0) {
		comparedResult.score = 1
	}

	dispatch({
		type: types.COMPARE_RANGES_SUCCESS,
		comparedResult,
	})
}

export const comparePolygons = (user, result, type) => (dispatch) => {
	dispatch({
		type: types.COMPARE_POLYGONS_REQUEST,
	})

	const comparedResult = {
		result,
		user,
		score: 0,
	}

	api.comparePolygons(type, user, result)
		.then((response) => {
			const { data } = response

			if (data && data.statusCode !== undefined && data.statusCode === 200) {
				return data.body.score
			}

			throw new Error('')
		})
		.then((score) => {
			comparedResult.score = score

			dispatch({
				type: types.COMPARE_POLYGONS_SUCCESS,
				comparedResult,
			})
		})
		.catch(() => {
			dispatch({
				type: types.COMPARE_POLYGONS_FAILED,
			})
		})
}

export const compareLabels = (user, result) => (dispatch) => {
	dispatch({
		type: types.COMPARE_LABELS_REQUEST,
	})

	const comparedResult = {
		result,
		user,
		score: 0,
	}

	if (result.toLowerCase() === user.toLowerCase()) { comparedResult.score = 1 }

	dispatch({
		type: types.COMPARE_LABELS_SUCCESS,
		comparedResult,
	})
}

export const clearResultRange = () => (dispatch) => {
	dispatch({
		type: types.COMPARE_RANGES_CLEAR,
	})
}
